module.exports = __webpack_public_path__ + "img/change- avatar.42b7a351.png";